import React from 'react';
import { GridRow, useGridApiContext } from '@mui/x-data-grid';
import { usePerson } from 'talent_matching/hooks/use_people';

// Injects the latest person from the query cache to keep
// row data in sync with the side panel.
const SyncedRow = (props: React.ComponentProps<typeof GridRow>) => {
  const apiRef = useGridApiContext();
  const { person } = usePerson(props.row.id);

  // After a reject/advance removes a row, there is a brief window where
  // MUI DataGrid still tries to render GridRow for the stale row ID,
  // so we need to bail out before GridRow hits the error in that case.
  if (!person || apiRef.current.getRow(props.rowId) === null) {
    return null;
  }

  return <GridRow {...props} row={person} />;
};

export default SyncedRow;
